"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Traverses a path to collect mutationExpressions into an expression.
 * This is needed because mutations can be chained.
 *
 * Requires:
 * - a mutationExpressions property on the path proxy
 */

var MutationExpressionsHandler =
/*#__PURE__*/
function () {
  function MutationExpressionsHandler() {
    _classCallCheck(this, MutationExpressionsHandler);
  }

  _createClass(MutationExpressionsHandler, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pathData) {
        var mutationExpressions, current;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mutationExpressions = []; // Add all mutationExpressions to the path

                current = pathData;

              case 2:
                if (!current) {
                  _context.next = 15;
                  break;
                }

                if (!current.mutationExpressions) {
                  _context.next = 12;
                  break;
                }

                _context.t0 = mutationExpressions.unshift;
                _context.t1 = mutationExpressions;
                _context.t2 = _toConsumableArray;
                _context.next = 9;
                return current.mutationExpressions;

              case 9:
                _context.t3 = _context.sent;
                _context.t4 = (0, _context.t2)(_context.t3);

                _context.t0.apply.call(_context.t0, _context.t1, _context.t4);

              case 12:
                // Move to parent link
                current = current.parent;
                _context.next = 2;
                break;

              case 15:
                return _context.abrupt("return", mutationExpressions);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return MutationExpressionsHandler;
}();

exports.default = MutationExpressionsHandler;